module.exports = __webpack_public_path__ + "static/img/preview.c74fbee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/magician-s-quest-banner-campaign/preview.png
// module id = 100
// module chunks = 2